module.exports = __webpack_public_path__ + "img/about-bg.db379e44.png";